import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideNgxMask } from 'ngx-mask';
import { catchError, lastValueFrom, of } from 'rxjs';
import { AuthService } from './shared/services/auth/auth.service';
import { csrfInterceptor } from './interceptors/csrf.interceptor';
import { credentialsInterceptor } from './interceptors/credentials.interceptor';

async function initCsrf(): Promise<void> {
  const auth = inject(AuthService);
  await lastValueFrom(auth.getCsrf().pipe(catchError(() => of(null))));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAppInitializer(initCsrf),
    provideHttpClient(
      withInterceptors([csrfInterceptor, credentialsInterceptor])
    ),
    provideNgxMask(),
  ],
};
